import React from 'react'
import { DialogTitle, DialogTitleProps } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { t } from 'ttag'
import { ReactComponent as CloseIcon } from '../../assets/v3/icons/close.svg'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import { useYumDialogContext } from '../YumDialog/YumDialog'

interface IYumDialogTitle extends DialogTitleProps {
  handleClose?: () => void
}

const YumDialogTitle = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: '24px',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
)(({ children, classes, handleClose, id, ...props }: IYumDialogTitle) => {
  // Fall back to the id provided by YumDialog so the dialog's aria-labelledby
  // resolves to this title element, giving the dialog an accessible name.
  const dialogContext = useYumDialogContext()
  const resolvedId = id ?? dialogContext?.titleId
  return (
    <DialogTitle disableTypography classes={classes} id={resolvedId} {...props}>
      <Typography variant="h6">{children}</Typography>
      {handleClose && (
        <button
          type="button"
          onClick={handleClose}
          title={t`Close`}
          aria-label={t`Close`}
          style={{
            width: 24,
            height: 24,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 0,
            padding: 0,
            color: 'inherit',
            font: 'inherit',
            cursor: 'pointer',
            lineHeight: 1,
            borderRadius: '50%',
          }}
        >
          <CloseIcon aria-hidden="true" />
        </button>
      )}
    </DialogTitle>
  )
})

export default YumDialogTitle
